import jsPDF from 'jspdf'; import { PDF_LAYOUT } from '../config/fonts';
export interface PageBreakOptions {
minSpaceAfter?: number;
elementType?: string;
keepWithNext?: boolean;
}

export class PageManager {
private pdf: jsPDF;
private pageHeight: number;
private pageWidth: number;
private currentY: number;
private safetyMargin: number = 10;

constructor(pdf: jsPDF) {
this.pdf = pdf;
this.pageHeight = pdf.internal.pageSize.getHeight();
this.pageWidth = pdf.internal.pageSize.getWidth();
this.currentY = PDF_LAYOUT.margins.top;
}

getCurrentY(): number {
return this.currentY;
}

setCurrentY(y: number): void {
this.currentY = y;
}

moveY(distance: number): void {
this.currentY += distance;
}

getPageWidth(): number {
return this.pageWidth;
}

getPageHeight(): number {
return this.pageHeight;
}

getContentWidth(): number {
return this.pageWidth - PDF_LAYOUT.margins.left - PDF_LAYOUT.margins.right;
}

// Add the missing resetToTop method
resetToTop(): void {
this.currentY = PDF_LAYOUT.margins.top;
}

checkForPageBreak(requiredSpace: number = 20, options: PageBreakOptions = {}): boolean {
const { minSpaceAfter = 10, elementType = 'content' } = options;
const totalSpaceNeeded = requiredSpace + minSpaceAfter + this.safetyMargin;
const availableSpace = this.pageHeight - PDF_LAYOUT.margins.bottom - this.currentY;


if (availableSpace < totalSpaceNeeded) {
  this.addPage();
  return true;
}
return false;
}

addPage(): void {
this.pdf.addPage();
this.currentY = PDF_LAYOUT.margins.top;
}

addSection(spacing: number = PDF_LAYOUT.spacing.section): void {
this.currentY += spacing;
this.checkForPageBreak();
}

addParagraph(spacing: number = PDF_LAYOUT.spacing.paragraph): void {
this.currentY += spacing;
}

addLine(spacing: number = PDF_LAYOUT.spacing.line): void {
this.currentY += spacing;
}

// Add method for element spacing with better control
addElement(elementHeight: number, options: PageBreakOptions = {}): void {
const { spacingAfter = PDF_LAYOUT.spacing.line } = options;
this.currentY += elementHeight + spacingAfter;
}

// Add method to enforce minimum spacing
enforceMinimumSpacing(minSpacing: number): void {
this.currentY += minSpacing;
}

// Get remaining space on current page
getRemainingSpace(): number {
return this.pageHeight - PDF_LAYOUT.margins.bottom - this.currentY;
}

// Check if we're near the bottom of the page
isNearPageBottom(threshold: number = 50): boolean {
return this.getRemainingSpace() < threshold;
}
}